import { stringifyFilter } from "./queryUtils";

export const buildImportMappingBasePath = ({ locale, projectId, fiscalYear, importId = "full" }) =>
    `/${locale}/${projectId}/${fiscalYear}/${importId}/import_mapping`;

export const buildCustomTemplateEditPath = ({
    locale,
    projectId,
    fiscalYear,
    importId = "full",
    profileId,
}) => {
    const search = new URLSearchParams({ viewMode: "source" });
    return `/${locale}/${projectId}/${fiscalYear}/${importId}/custom_templates/${profileId}?${search.toString()}`;
};

export const buildDataProcessingLogPath = (basePath, filters = []) => {
    if (!filters.length) {
        return `${basePath}/data_sync_log`;
    }
    return `${basePath}/data_sync_log?filter=${stringifyFilter(filters)}`;
};

export const buildDataChangeLogPath = (basePath, filters = []) => {
    if (!filters.length) {
        return `${basePath}/data_change_history`;
    }
    return `${basePath}/data_change_history?filter=${stringifyFilter(filters)}`;
};

export const buildEntityNameLogFilter = (entityName) =>
    entityName
        ? [{ column: "EntityName", operator: "equals", filters: [{ value: String(entityName) }] }]
        : [];

export const buildEntityLogFilter = (entity) =>
    entity ? [{ column: "Entity", operator: "equals", filters: [{ value: String(entity) }] }] : [];

export const resolveImportProfileLogEntity = ({ profileName, profileId }) =>
    profileName || (profileId ? String(profileId) : "");
